<template>
    <div class="titleBlock" :class="{'titleBlock--withContent': secondaryContent}">
        <h2 class="subTitle" v-if="primarySubtitle">{{ primarySubtitle }}</h2>
        <h1 class="title" v-if="primaryTitle" v-html="primaryTitle"></h1>
        <h1 class="secondaryTitle" v-if="primaryTitle" v-html="secondaryTitle"></h1>
        <div class="text" :class="{'text--fullWidth': fullwidth}" v-if="secondaryContent" >
            <span v-html="secondaryContent"></span>
            <ButtonPulse v-if="buttonText" :btnContent="buttonText" iconType="arrow" class="button" @click="$emit('buttonPulseClick')"/>
        </div>
    </div>
</template>

<script>
import ButtonPulse from '@/components/ButtonPulse'

export default {
    name: 'TitleBlock',
    props: ['primaryTitle', 'primarySubtitle', 'secondaryTitle', 'secondaryContent', 'buttonText', 'fullwidth'],
    components: {
        ButtonPulse
    }
}
</script>

<style scoped lang="scss">

.titleBlock {
    background-color: $colour__primary1;
    color: $white;
    position: absolute;
    text-align: left;
    padding: 3rem 3rem 3rem 3rem;
}
.title {
    font-size: 4.8rem;
    line-height: 1;
}
.secondaryTitle {
    font-size: 1.8rem;
    font-family: $fontFamily--light;
    margin-top: 1rem;
}
.subTitle {
    margin-bottom: 1rem;
    text-transform: uppercase;
    color: $colour__accent1;
    font-size: 1.8rem;
}

.text {
    background-color: $colour__primary2;
    color: $colour__primary1;
    padding: 3rem 3rem 3rem 3rem;
    font-size: 1.6rem;
    position: absolute;
    top: 100%;
    margin-top: -1.5rem;
    left: 3rem;
    display: inline-block;
    width: calc(100% + 6rem);   
    &--fullWidth {
        width: calc(100vw - 6rem - (#{$padding} * 2)) ;
        max-width: 55vw;
    }
}
.button {
    position: absolute;
    top: 100%;
    margin-top: -3rem;
    right: -3rem;
}
</style>
